<template>
    <el-dialog :title="$t('Manage closed booking year')" :visible.sync="closeBookingDialog" :before-close="handleClose" @open="handleOpen()" width="80%">
        <el-row>
            <el-col>
                <div class="table-grd">
                    <v-collapse-group ref="group1">
                        <v-collapse-wrapper ref="toggle_second">
                            <div class="my-content table-desc">
                                <div class="my-content">
                                    <el-form :model="formData" ref="formData" :inline="true" @submit.native.prevent novalidate :rules="rules">
                                        <el-col :xs="24" :sm="8" :md="8" :lg="4" :xl="3">
                                            <el-form-item prop="start_date">
                                                <el-date-picker :picker-options="datePickerOptions" size="small" style="width:100%;" v-model="formData.start_date" type="date" :placeholder="$t('Start date')" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="8" :md="8" :lg="4" :xl="3">
                                            <el-form-item prop="end_date">
                                                <el-date-picker :picker-options="datePickerOptions" size="small" style="width:100%;" v-model="formData.end_date" type="date" :placeholder="$t('End date')" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="4">
                                            <div class="el-form-item">
                                                <el-button type="primary" @click="submitForm('formData')" size="small">{{
                                                    $t('Close booking year') }}</el-button>
                                            </div>
                                        </el-col>
                                    </el-form>
                                </div>
                                <el-table :data="ranges.data" @sort-change="handleSortChange" fit highlight-current-row key='aTable'>
                                    <el-table-column :label="$t('Actions')" width="300" fixed>
                                        <template slot-scope="scope">
                                            <ul class="act-list">
                                                <li>
                                                    <el-button v-if="scope.row.is_locked == 'yes'" class="resetButtonBooking" type="cancel" @click="handleEdit(scope.row)" size="small" :disabled="scope.row.flag != '1'">{{
                                                        $t('Reset booking year') }}</el-button>
                                                    <el-button v-else type="primary" @click="handleEdit(scope.row)" size="small">{{
                                                        $t('Close booking year') }}</el-button>
                                                </li>
                                            </ul>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Start date')" sortable="custom" prop="start_date" width="200">
                                        <template slot-scope="scope">
                                            <span v-date-format="scope.row.start_date"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('End date')" sortable="custom" prop="end_date" width="200">
                                        <template slot-scope="scope">
                                            <span v-date-format="scope.row.end_date"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Created at')" sortable="custom" prop="created_at" width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.created_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Modified at')" sortable="custom" prop="updated_at" width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.updated_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="10"></el-table-column>
                                </el-table>
                                <el-pagination v-if="ranges.meta.total" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filterData.page" :page-sizes="[6, 12, 24, 66, 111]" :page-size="filterData.pageLength" layout="sizes, slot, ->, prev, pager, next" :total="ranges.meta.total">
                                    <template>
                                        <span class="page-no"> {{ $t('Showing out of records', {'0': ranges.data.length,
                                            '1':
                                            ranges.meta.total}) }} </span>
                                    </template>
                                </el-pagination>
                            </div>
                        </v-collapse-wrapper>
                    </v-collapse-group>
                </div>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            AccSettings: Object,
            closeBookingDialog: Boolean
        },
        data() {
            return {
                datePickerOptions: {
                    disabledDate(date) {
                        return date > new Date()
                    }
                },
                filterData: {
                    page: 1,
                    pageLength: process.env.KIPAKI_pageLength,
                    sortBy: "id",
                    order: "desc",
                },
                ranges: {
                    meta: {},
                    data: []
                },
                formData: {},
                rules: {
                    'start_date': [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: 'change'
                    }],
                    'end_date': [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: 'change'
                    }]
                },
            };
        },
        mounted() {
            this.getRanges();
        },
        methods: {
            handleOpen() {
                this.formData = this.AccSettings;
            },
            handleClose() {
                this.$emit('popup', false)
            },
            getRanges() {
                request({
                    url: "locked-bookings",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.ranges = response.data;
                });
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        request({
                                url: "locked-bookings",
                                method: "post",
                                data: this.formData
                            })
                            .then(response => {
                                this.getRanges();
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            },
            handleEdit(row) {
                var cRow = Object.assign({}, row);
                var s = '';
                if (row.is_locked == 'yes') {
                    s = this.$t('reset freezed');
                    cRow.is_locked = 'no';
                } else {
                    s = this.$t('freeze');
                    cRow.is_locked = 'yes';
                }
                this.$confirm(
                    this.$t('Are you sure want to ' + s + ' booking list?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('Yes'),
                        cancelButtonText: this.$t('No'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    request({
                            url: "locked-bookings/" + cRow.id,
                            method: "PATCH",
                            data: cRow
                        })
                        .then(response => {
                            Object.assign(row, response.data.data);
                            this.$notify({
                                title: this.$t('Success'),
                                message: response.data.message,
                                type: "success",
                                offset: 50
                            });
                        })
                        .catch(error => {
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                        });
                });
            },
            handleCurrentChange(event) {
                this.filterData.page = 1;
                this.getRanges(this.filterData.current_page);
            },
            handleSizeChange(event) {
                this.filterData.pageLength = event;
                this.getRanges();
            },
            handleSortChange(event) {
                this.filterData.sortBy = event.prop;
                if (event.order === "ascending") this.filterData.order = "asc";
                else if (event.order === "descending") this.filterData.order = "desc";
                else {
                    this.filterData.sortBy = "id";
                    this.filterData.order = "desc";
                }
                this.getRanges();
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.getRanges();
            },
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Accounts/AccountFreeze.vue